import {
  Container,
  Stat,
  StatGroup,
  StatLabel,
  StatNumber
} from '@chakra-ui/react'
import { Page } from 'client/layouts/pages/page'
import { api } from 'client/services/api'
import { GetStaticProps, NextPage } from 'next'
import { PHASE_PRODUCTION_SERVER } from 'next/constants'
import React from 'react'
import {
  getPublicStatsReply,
  GetPublicStatsReply
} from 'server/routes/public/stats'

export interface PublicStatsPageProps {
  stats: GetPublicStatsReply
}

const PublicStatsPage: NextPage<PublicStatsPageProps> = ({ stats }) => {
  return (
    <Page title="Public stats">
      <Container my={8}>
        <StatGroup textAlign="center">
          <Stat>
            <StatNumber>{stats.counts.users ?? '--'}</StatNumber>
            <StatLabel>Users</StatLabel>
          </Stat>
          <Stat>
            <StatNumber>{stats.counts.projects ?? '--'}</StatNumber>
            <StatLabel>Projects</StatLabel>
          </Stat>
          <Stat>
            <StatNumber>{stats.counts.messages ?? '--'}</StatNumber>
            <StatLabel>Messages</StatLabel>
          </Stat>
        </StatGroup>
      </Container>
    </Page>
  )
}

export default PublicStatsPage

export const getStaticProps: GetStaticProps<
  PublicStatsPageProps
> = async () => {
  const props: PublicStatsPageProps = {
    stats: {
      counts: {
        users: NaN,
        projects: NaN,
        messages: NaN
      },
      platformUsage: {
        days: {},
        months: {}
      }
    }
  }
  try {
    // Rebuild the page with fresh stats in ISR
    // Note: this will run at build time, where there *may* be no server
    // listening, hence the try/catch.
    // There may be a listening server when deploying on Clever Cloud
    // (the old instance in a blue/green deployment orchestration),
    // but in a local dev environment or in CI, there won't be any.
    const res = await api.get<{ Reply: GetPublicStatsReply }>(
      `http://localhost:${process.env.PORT}/api/public/stats`,
      {
        headers: {
          'user-agent': 'axios/server-side/isr'
        }
      }
    )
    props.stats = getPublicStatsReply.parse(res.data)
  } catch {
    if (process.env.NEXT_PHASE === PHASE_PRODUCTION_SERVER) {
      // This is a production runtime error
      // todo: Report to Sentry if error is not "failed to connect to server"
      // How do we get to Sentry from here though?
    }
  }
  return {
    props,
    // Shorten ISR revalidation time when no data is available
    revalidate: Number.isSafeInteger(props.stats.counts.users)
      ? 3600 // 1 hour
      : 60 // 1 minute
  }
}
